import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

const EXPLORE = [
  { id: "home", label: "Home" },
  { id: "about", label: "About 841" },
  { id: "strength", label: "Strength" },
  { id: "balance", label: "Balance" },
  { id: "self", label: "Self" },
  { id: "pricing", label: "Pricing" },
];

const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy", id: "privacy" },
  { to: "/terms", label: "Terms of Service", id: "terms" },
  { to: "/support", label: "Support", id: "support" },
];

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-[#1C1917] text-sand">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-20 lg:px-12">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-5xl tracking-tight">841</span>
            <span className="text-[11px] uppercase tracking-[0.3em] text-gold">wellness</span>
          </div>
          <p className="mt-4 font-serif text-xl italic text-gold/90">
            strength • balance • self
          </p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#A79E96]">
            A personalised holistic wellness app for women — stronger, more balanced, and more
            connected to yourself.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-gold/80">
            Explore
          </p>
          <ul className="mt-5 space-y-3">
            {EXPLORE.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="text-sm text-[#C9C0B8] transition-colors duration-300 hover:text-sand"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-gold/80">
            Legal & help
          </p>
          <ul className="mt-5 space-y-3">
            {LEGAL_LINKS.map((l) => (
              <li key={l.id}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm text-[#C9C0B8] transition-colors duration-300 hover:text-sand"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-[#8A8079] sm:flex-row">
        <p>© 2026 841 wellness. All rights reserved.</p>
        <p className="font-serif italic text-gold/60">strength • balance • self</p>
      </div>
    </div>
  </footer>
);
